import { createContext, useContext } from 'react';

interface ThemeContextProps {
    currentTheme: 'light' | 'dark';
    setThemePreference: (theme: 'light' | 'dark') => void;
    toggleThemePreference: () => void;
}

const ThemeContext = createContext<ThemeContextProps>({
    currentTheme: 'light',
    setThemePreference: () => {},
    toggleThemePreference: () => {},
});

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;
